// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"449":"e8fe9daa","482":"3b220a7c"}[chunkId] + ".chunk.css";
};